import http from "@/http";
import store from "@/store";

// Mahalla mablag'lari sarfi hisobotlari (year + quarter -> bitta fayl).
// Spec pathlari `/v1/...` ko'rinishida yozilgan; bu consoleda barcha endpoint
// `api/v1/...` ostida (http instance baseURL = VUE_APP_BASE_API_URL).
const BASE = "api/v1/mahalla-fund-reports";

export const QUARTERS = [1, 2, 3, 4];

// Global request limiti 20 MB — faylni requestdan oldin rad etamiz.
export const MAX_FILE_SIZE = 20 * 1024 * 1024;

export default {
  // year berilmasa barcha active yozuvlar keladi (sort: year DESC, quarter ASC).
  list(year) {
    return http.get(BASE, { params: year ? { year } : {} });
  },
  // Idempotent upsert: mavjud davr bo'lsa backend eskisini soft-delete qiladi.
  attach({ year, quarter, file_id }) {
    return http.put(BASE, { year, quarter, file_id });
  },
  // Relation soft-delete; fayl storage'da qoladi.
  remove(id) {
    return http.delete(`${BASE}/${id}`);
  },
  // Public download endpoint — binary body qaytaradi.
  download(fileId) {
    return http.get(`api/v1/download/${fileId}`, {
      params: { type: "SMALL" },
      responseType: "blob",
    });
  },
};

// ---- Fayl upload ----
// Multipart upload el-upload (native XHR) orqali ketadi, shared axios instance
// orqali emas: uning transformRequest'i har bodyni JSON.stringify qiladi va
// FormData'ni buzadi. Bu consoledagi boshqa upload oqimlari bilan bir xil.
// Content-Type qo'lda o'rnatilmaydi — boundary'ni browser qo'yadi.
export function uploadUrl() {
  return `${process.env.VUE_APP_BASE_API_URL}api/v1/file-upload`;
}

export function uploadHeaders() {
  return { Authorization: `${store.state.accessToken}` };
}

// ---- Helperlar ----
export function formatFileSize(bytes) {
  if (bytes === null || bytes === undefined || Number.isNaN(Number(bytes))) return "—";
  const size = Number(bytes);
  if (size < 1024) return `${size} B`;
  const units = ["KB", "MB", "GB"];
  let value = size / 1024;
  let unit = 0;
  while (value >= 1024 && unit < units.length - 1) {
    value /= 1024;
    unit += 1;
  }
  return `${value.toFixed(1)} ${units[unit]}`;
}

// Fayl yuklab olish helperlari umumiy — bir nechta modul ishlatadi.
// Bu yerdan re-export qilinadi, chunki view'lar ularni shu moduldan import qiladi.
export { filenameFromResponse, saveBlob } from "@/utils/common";
